import { SvrAPk } from "../../utils/axios";
/**
 * Metodo que consulta los servicios
 */
const getServicios = async (AreaId) => {
  let res = {};
  try {
    res = await SvrAPk.post("/api/public/service/getservicios", { AreaId });
  } catch (Error) {
    res = Error;
  }
  return res;
};

export { getServicios };
